module.exports = __webpack_public_path__ + "img/Wechselladerfahrzeug.ff9f6c1f.svg";